module.exports = __webpack_public_path__ + "img/h_referral.e3e30040.svg";